import { Button, Stack } from "@mui/material";

import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import * as z from "zod";

import { useCreateNotificationHandlerNotificationHandlersPostMutation } from "api";
import { TextInput } from "components/forms";
import { INotificationHandlerSensio } from "interfaces/notification.interface";

const sensioHandlerSchema = z.object({
  description: z.string(),
  configuration: z.object({
    client_id: z.string(),
    client_secret: z.string(),
    username: z.string(),
    password: z.string(),
    api_base_url: z.url(),
  }),
});

type SensioHandlerSchema = z.infer<typeof sensioHandlerSchema>;

type TempSensioProps = {
  disabled: boolean;
  zoneId: string;
  onClose: () => void;
  defaultValues: INotificationHandlerSensio | null;
};

export function TempSensio({
  disabled,
  zoneId,
  onClose,
  defaultValues,
}: TempSensioProps) {
  const { t } = useTranslation();

  const [createHandler] =
    useCreateNotificationHandlerNotificationHandlersPostMutation();

  const { control, handleSubmit } = useForm<SensioHandlerSchema>({
    resolver: zodResolver(sensioHandlerSchema),
    defaultValues: defaultValues ?? {},
  });

  const onCreate = async (data: SensioHandlerSchema) => {
    await createHandler({
      notificationHandlerCreate: {
        type: "sensio",
        zone_id: zoneId,
        enabled: true,
        description: data.description,
        configuration: {
          ...data.configuration,
          grant_type: "password",
        },
      },
    });

    onClose();
  };
  return (
    <Stack component={"form"} onSubmit={handleSubmit(onCreate)} gap={1}>
      <TextInput
        fieldName={"description"}
        control={control}
        label={t("Description")}
        placeholder={t("notification_sensio_handler_description_placeholder")}
        disabled={disabled}
        required
      />
      <TextInput
        fieldName={"configuration.username"}
        control={control}
        label={t("login_name")}
        placeholder={t("notification_sensio_handler_username_placeholder")}
        disabled={disabled}
        required
      />
      <TextInput
        fieldName={"configuration.password"}
        control={control}
        label={t("Password")}
        placeholder={t("notification_sensio_handler_password_placeholder")}
        disabled={disabled}
        required
      />
      <TextInput
        fieldName={"configuration.client_id"}
        control={control}
        label={t("notification_sensio_handler_client_id")}
        placeholder={t("notification_sensio_handler_client_id_placeholder")}
        disabled={disabled}
        required
      />
      <TextInput
        fieldName={"configuration.client_secret"}
        control={control}
        label={t("notification_sensio_handler_client_secret")}
        placeholder={t("notification_sensio_handler_client_secret_placeholder")}
        disabled={disabled}
        required
      />
      <TextInput
        fieldName={"configuration.api_base_url"}
        control={control}
        label={t("notification_handler_api_base_url")}
        placeholder={t("notification_sensio_handler_api_base_url_place_holder")}
        disabled={disabled}
        required
      />
      <Stack gap={2} direction={"row"}>
        {!defaultValues && <Button type={"submit"}>{t("Create")}</Button>}
        <Button variant={"text"} onClick={onClose}>
          {t("Cancel")}
        </Button>
      </Stack>
    </Stack>
  );
}
